import { Box, Typography } from '@mui/material';

// Credite pe categorii pe Dashboard; props: [{ label, value, bgcolor, color }]
export default function CategoryCredits({ categories = [] }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, width: '100%' }}>
      {categories.map((cat) => (
        <Box
          key={cat.label}
          sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}
        >
          <Box sx={{
            p: 2,
            borderRadius: 3,
            bgcolor: cat.bgcolor || '#f5f5f5',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 120
          }}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color={cat.color}
              sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' }, lineHeight: 1.2 }}
            >
              {cat.value}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' }, textAlign: 'center' }}>
              {cat.label}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
